/**
 * EmailJS credentials, resolved when they are needed rather than at import.
 *
 * Create React App inlines REACT_APP_* at build time either way, so this costs
 * nothing in production — but it keeps the lookup in one place and lets tests
 * exercise the misconfigured paths without reloading modules.
 *
 * A dedicated chat template is preferred when present, falling back to the
 * contact-form template so chat inquiries still deliver before that template
 * has been created. The older VOICE variable is still honoured so existing
 * deployments keep working.
 */
export function getMailConfig() {
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || "";
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "";
  const contactTemplateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "";
  const templateId =
    process.env.REACT_APP_EMAILJS_CHAT_TEMPLATE_ID ||
    process.env.REACT_APP_EMAILJS_VOICE_TEMPLATE_ID ||
    contactTemplateId;

  return {
    serviceId,
    publicKey,
    templateId,
    contactTemplateId,
    ready: Boolean(serviceId && publicKey && templateId),
  };
}
